// hooks/useCheckTokenAndPaymentStatus.js
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../Services/auth.service';
import UserService from '../Services/user.service';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export const useCheckTokenAndPaymentStatus = () => {
  const [isPaid, setIsPaid] = useState(true); // Default to true to not block UI initially
  const [checked, setChecked] = useState(false); // Ensure we only render after check
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const validate = async () => {
      try {
        const token = await UserService.getCurrentToken();
        const res = await AuthService.CheckTokenValidation(token);
        
        if (!res.isValid) {
          toast.info(t('YouNeedToLogInAgain'));
          await AuthService.logout();
          navigate('/login');
        } else {
          setIsPaid(res.paid);
          setChecked(true);
        }
      } catch (error) {
        toast.info(t('YouNeedToLogInAgain'));
        await AuthService.logout();
        navigate('/login');
      }
    };

    validate();
  }, [navigate, t]);

  return { isPaid, checked };
};
